'use strict';

const HighlightCurrent = require('./components/highlightCurrent');
const PresetsChooser = require('./components/forms/PresetChooser');

$(document).ready(() => {
    const asideMenu = document.querySelector('[data-js-highlight-current]');
    if (asideMenu) {
        new HighlightCurrent(asideMenu).init();
    }

    // Donation form chooser
    const donationFormPresets = document.querySelector('[data-js-preset-chooser]');
    if (donationFormPresets) {
        new PresetsChooser(donationFormPresets).init();
    }
});
